module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"purchased_at":"{0} 购买","best_review_reward":"入选优质评价，最高可获{0}！"}}')
  delete Component.options._Ctor
}
